import { render, staticRenderFns } from "./OldAccountBanner.vue?vue&type=template&id=88d2a36c&scoped=true&"
import script from "./OldAccountBanner.vue?vue&type=script&lang=js&"
export * from "./OldAccountBanner.vue?vue&type=script&lang=js&"
import style0 from "./OldAccountBanner.vue?vue&type=style&index=0&id=88d2a36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d2a36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88d2a36c')) {
      api.createRecord('88d2a36c', component.options)
    } else {
      api.reload('88d2a36c', component.options)
    }
    module.hot.accept("./OldAccountBanner.vue?vue&type=template&id=88d2a36c&scoped=true&", function () {
      api.rerender('88d2a36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/banners/OldAccountBanner.vue"
export default component.exports